<div id="kanban">
  <dx-scroll-view
    class="scrollable-board"
    direction="horizontal"
    showScrollbar="always"
  >
    <dx-sortable
      class="sortable-lists"
      itemOrientation="horizontal"
      handle=".list-title"
      (onReorder)="onListReorder($event)"
    >
      <div class="list" *ngFor="let list of lists; let listIndex = index">
        <div class="list-title" *ngIf="statuses[listIndex]">{{ statuses[listIndex].Name }}</div>
        <dx-scroll-view
          class="scrollable-list"
          direction="vertical"
          showScrollbar="always"
        >
          <dx-sortable
            class="sortable-cards"
            group="cardsGroup"
            [data]="list"
            (onDragStart)="onTaskDragStart($event)"
            (onReorder)="onTaskDrop($event)"
            (onAdd)="onTaskDrop($event)"
          >
            <div class="card dx-card m-2" *ngFor="let message of list">
              <div class="row">
                <div class="card-subject" class="col-10">{{ message.Name }}</div>
                <dx-drop-down-button class="col-auto">
                  <fa-icon [icon]="faEllipsisV"></fa-icon>
                </dx-drop-down-button>
              </div>
              <div>
                <dx-button (onClick)="openModal(msgDetailTemplate, '', message)"><fa-icon [icon]="faInfoCircle"></fa-icon></dx-button>
                <dx-button class="m-2"><fa-icon [icon]="faTrashCan"></fa-icon></dx-button>
              </div>
            </div>
            <dx-button class="m-2" (onClick)="openModal(msgTemplate, statuses[listIndex].Name, undefined)">
              + Add message to board
            </dx-button>
            <dx-button class="m-2" (onClick)="deleteBoard(statuses[listIndex].Id)" [disabled]="list.length > 0">
              <fa-icon [icon]="faTrashCan"></fa-icon>
            </dx-button>
          </dx-sortable>
        </dx-scroll-view>
      </div>
    </dx-sortable>
    <dx-button class="m-2" (onClick)="openModal(template, '', undefined)">
      + Add another board
    </dx-button>
  </dx-scroll-view>

  <ng-template #template>
    <div class="content-block dx-card responsive-paddings pt-35">
      <div class="modal-body text-center">
        <dx-form [formGroup]="frmData">
          <div class="form-group" class="ml-5">
            <div class="row">
              <div class="form-group">
                <label for="name">Card Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  [placeholder]="'Card Name'"
                  aria-describedby="name"
                  formControlName="Name"
                  name="name"
                  autocompleteOff
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <label for="name">Machine Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  [placeholder]="'ticket-respond-machine-name' | translateWithFallback"
                  aria-describedby="name"
                  formControlName="SourceId"
                  name="name"
                  autocompleteOff
                />
              </div>
            </div>
            <div class="row m-2">
              <div class="col-lg-6 col-sm-12">
                <dx-button
                  class="btn btn-primary"
                  (click)="decline()"
                >
                {{ 'ticket-respond-cancel' | translateWithFallback }}
                </dx-button>
              </div>
              <div class="col-lg-6 col-sm-12">
                <dx-button class="btn btn-primary" (click)="save()">
                  {{ 'ticket-respond-save' | translateWithFallback }}
                </dx-button>
              </div>
            </div>
          </div>
        </dx-form>
      </div>
    </div>
  </ng-template>
  <ng-template #msgTemplate>
    <div class="dx-card modal-body text-center">
      <dx-form [formGroup]="msgFrmData">
        <div class="form-group" class="ml-5">
          <div class="row m-2">
            <div formGroupName="MessageSource">
              <label class="mb-2" for="MessageSource">{{ 'ticket-respond-message-source' | translateWithFallback }}</label>
              <div class="col-lg">
                <label for="SubjectType">{{ 'ticket-respond-subject-type' | translateWithFallback }}</label>
                <dx-select-box
                  [items]="this.MsgSvc.relationSubject"
                  formControlName="SubjectType"
                >
                </dx-select-box>
              </div>
              <div class="col-lg"></div>
            </div>
          </div>

          <div class="row m-2">
            <label class="mb-2" for="Message">{{ 'ticket-respond-message' | translateWithFallback }}</label>
            <div class="col-sm">
              <div class="form-group">
                <label for="name">{{ 'ticket-respond-title' | translateWithFallback }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  [placeholder]="'ticket-respond-title' | translateWithFallback"
                  aria-describedby="name"
                  formControlName="Name"
                  name="name"
                  autocompleteOff
                />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label for="name">{{ 'ticket-respond-machine-respond-name' | translateWithFallback }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  [placeholder]="'ticket-respond-machine-name' | translateWithFallback"
                  aria-describedby="name"
                  formControlName="SourceId"
                  name="name"
                  autocompleteOff
                />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label for="MessageType">{{ 'ticket-respond-message-type' | translateWithFallback }}</label>
                <dx-select-box
                  [items]="this.MsgSvc.messageType"
                  formControlName="MessageType"
                >
                </dx-select-box>
              </div>
            </div>
          </div>

          <div class="row m-2">
            <div class="form-group">
              <label for="MessageContent">{{ 'ticket-respond-message-content' | translateWithFallback }}</label>
              <dx-text-area
                [height]="90"
                [maxLength]="250"
                formControlName="MessageContent"
              >
              </dx-text-area>
            </div>
          </div>
        </div>

        <div class="row m-2">
          <div class="col-lg">
            <dx-button
              class="btn btn-primary"
              (onClick)="decline()"
            >
            {{ 'ticket-respond-cancel' | translateWithFallback }}
            </dx-button>
          </div>
          <div class="col-auto">
            <dx-button class="btn btn-primary" (click)="saveMsg(Msg?.Id)">
              {{ 'ticket-respond-save' | translateWithFallback }}
            </dx-button>
          </div>
        </div>
      </dx-form>
    </div>
  </ng-template>
  <ng-template #msgDetailTemplate>
    <div class="dx-card card-container pt-50">
      <div class="row m-2">
        <div class="col-sm">
          <h5>{{ Msg?.Name }}</h5>
        </div>
        <div class="col-sm">{{ Msg?.Created | date:'dd/MM/yyyy hh.mm.ss' }}</div>
      </div>
      <div class="row m-2">
        <div class="col-sm">
          {{ Msg?.MessageContent }}
        </div>
      </div>
    </div>
  </ng-template>
</div>
